import { BaseCard } from "@fero/components";
import { Stack, Typography } from "@mui/material";
import type React from "react";
import { ImportPriceListButton } from "./import-price-list-button";

export const ImportPriceListCard: React.FC = () => {
  return (
    <BaseCard spacing={4}>
      <Stack spacing={2}>
        <Typography fontWeight={500} fontSize={20} textAlign={"center"}>
          Manage products available for sale
        </Typography>
        <Typography fontSize={16} textAlign={"center"}>
          Add default sale prices that apply automatically for Trade Sale
          Orders.
        </Typography>
      </Stack>
      <Stack alignItems={"center"}>
        <ImportPriceListButton />
      </Stack>
    </BaseCard>
  );
};
